/*
 * Lightweight scroll-reveal, no framework dependency. Adds `.is-visible`
 * to any `[data-scroll-reveal]` element the first time it enters the
 * viewport. Pairs with CSS transitions defined per-section. Respects
 * prefers-reduced-motion by revealing everything immediately.
 */
(function () {
  var targets = document.querySelectorAll('[data-scroll-reveal]');
  if (!targets.length) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) {
    targets.forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
})();
